import React, { useContext, useMemo } from 'react'
import './OfflineTopBar.css'
import UserContext from '../../context/UserContext'

function OfflineTopBar() {
  const myContext = useContext(UserContext)

  const teamUsers = (myContext?.team ?? []) 
  const avatars = useMemo(() => teamUsers.slice(0, 5), [teamUsers])
  const extraCount = Math.max(0, teamUsers.length - avatars.length)

 

  const myClassName = "ecd-titlebar-offline";

  return (
    <div className={myClassName} >
      {/* Top Row */}
      <div className="ecd-titlebar-top"  >
        <div style={{ color: "white" }}>
          <button style={{ background: "transparent", border: 0 }}>
            <img
              src={require("../../assets/points.png")}
              width={18}
              height={18}
              alt="Menu button"
            />
          </button>
        </div>

        <div style={{ flex: 1, textAlign: "center" }}>
          Welcome to EasyChatDesk
        </div>

        <div style={{ color: "white" }}>
          <button
            className="minBtn"
            style={{ background: "transparent", border: 0 }}
            onClick={() => {
              window.parent.postMessage(
                { action: 'minimizeFullChatWidget', newStyle: '' },
                '*'
              )
            }}
          >
            <img
              src={require("../../assets/minimize-sign.png")}
              width={16}
              height={16}
              alt="Minimize button"
            />
          </button>

          {myContext.chatStarted === true && (
            <button
              onClick={() => { myContext.closeChat(); }}
              style={{ background: "transparent", border: 0 }}
            >
              <img
                src={require("../../assets/close.png")}
                width={16}
                height={16}
                alt="Close button"
              />
            </button>
          )}
        </div>
      </div>

      {/* Bottom Row */}
      <div className="ecd-titlebar-bottom" style={{paddingTop:25, paddingBottom: 25}}>
        {/* New avatar stack */}
        <div className="ecd-avatar-stack" aria-label="Support team">
          {avatars.length > 0 ? (
            <>
              {avatars.map((u, i) => (
                <img
                  key={`${u.name}-${i}`}
                  className="ecd-avatar"
                  src={u.avatar_url}
                  alt={u.name}
                  title={u.name}
                  style={{ zIndex: 100 - i }} // keep left-most on top
                  loading="lazy"
                />
              ))}
              {extraCount > 0 && (
                <div className="ecd-avatar ecd-avatar-more" title={`+${extraCount} more`}>
                  +{extraCount}
                </div>
              )}
            </>
          ) : (
            <img
              className="ecd-avatar"
              src="https://easychatdesk.com/images/avatar.png"
              alt="Support"
              title="Support"
              loading="lazy"
            />
          )}
        </div>

        <div className="offline-message">
          Our team is not online, but we will reply within 24 hours or less, we promise.
        </div>
      </div>
    </div>
  )
}

export default OfflineTopBar
